import React from 'react';
import ScreenComponent from './ScreenComponent';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert, login, userRefresh, setView, topbarUpdate } from "../../actions";
import '../../styles/elements/screen.scss';
import '../../styles/screens/settings.scss';
import {config} from "../../app/config";
import MD5 from "crypto-js/md5";
import axios from "axios";
import { Confirmation } from "../Confirmation";
import { LicenseComponent } from "./settings/LicenseComponent";
import TranslationService from "../../app/services/TranslationService";
import SystemInfoService from "../../app/services/SystemInfoService";
import {Button} from "../icymat-design/Button";
import {Select} from "../icymat-design/Select";


export class SettingsScreen extends ScreenComponent {

    /**
     * @param props
     */
    constructor(props)
    {
        super(props);

        this.state = {
            tab: 'account',
            devices: [],
            delete_device: null,
            edit_device: null,
            edit_device_name: '',
            voice: localStorage.getItem('voice') === 'enabled' ? 'enabled' : 'disabled',
            talk_screen: localStorage.getItem('talk_screen') === 'calm' ? 'calm' : 'standard'
        };
    };

    /**
     * @param prevProps
     * @param prevState
     */
    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadDevices();
            this.props.topbarUpdate({
                action1: null,
                action2: null,
                actionBig: null
            });
        }
    };

    /**
     * @returns {string}
     */
    getScreenName() {
        return 'settings';
    }

    /**
     * Load devices
     */
    loadDevices = () => {
        this.props.preloaderShow();
        let that = this;

        axios.get(config.apiAddress + '/devices')
            .then(function (response) {
                that.setState({devices: response.data});
                that.props.preloaderHide();
            }).catch(function(error) {
                that.props.alert('Nie udało się załadować urządzeń');
            });
    };

    /**
     * @returns {[]}
     */
    renderDevices = () => {
        let devices = [];

        let that = this;
        Object.keys(this.state.devices).forEach(function(key) {
            devices.push(<tr key={key}>
                <td>{that.state.devices[key].name}</td>
                <td>{that.state.devices[key].id}</td>
                <td>
                    <Button
                        color={'accent'}
                        secondary={true}
                        text={TranslationService.trans(that.props.language, 'settings.devices.change_name')}
                        size={'sm'}
                        onClick={() => that.setState({edit_device: that.state.devices[key].id, edit_device_name: that.state.devices[key].name})}
                        display={that.state.devices[key].name[0] !== '_'}
                        style={{marginRight: '7px'}}
                    />

                    <Button
                        color={'red'}
                        secondary={true}
                        text={TranslationService.trans(that.props.language, 'common.delete')}
                        size={'sm'}
                        onClick={() => that.setState({delete_device: config.apiAddress + '/devices/' + that.state.devices[key].id})}
                    />
                </td>
            </tr>);
        });

        return devices;
    };

    /**
     * @returns string
     */
    getCurrentDeviceName = () => {
        let name = 'noname';

        let that = this;
        Object.keys(this.state.devices).forEach(function(key) {
            if (that.state.devices[key].id === that.props.device) {
                name = that.state.devices[key].name;
            }
        });

        return name;
    };

    /**
     * Action on delete success
     */
    deleteDeviceSuccess = (response, address) => {
        this.setState({delete_device: null});
        this.loadDevices();
        this.props.alert(TranslationService.trans(this.props.language, 'settings.devices.actions.device_removed'));
    };

    /**
     * Action on delete error
     */
    deleteDeviceError = (error, address) => {
        this.props.alert(TranslationService.trans(this.props.language, 'settings.devices.actions.device_remove_failed'));
    };

    /**
     * Save device
     */
    saveDevice = () => {
        this.props.preloaderShow();
        let that = this;

        axios.put(config.apiAddress + '/devices/' + that.state.edit_device, {name: that.state.edit_device_name})
            .then(function (response) {
                that.setState({edit_device: null});
                that.props.alert(TranslationService.trans(that.props.language, 'settings.devices.actions.device_saved'));
                that.loadDevices();
            }).catch(function(error) {
                that.setState({edit_device: null});
                that.props.alert(TranslationService.trans(that.props.language, 'common.actions.save_failed'));
                that.props.preloaderHide();
            });
    };

    /**
     * Logout from the App
     */
    logout = () => {
        localStorage.removeItem('identity');
        localStorage.removeItem('email');
        localStorage.removeItem('device');

        this.props.login({
            email: null,
            identity: null,
            device: null,
            domain: null
        });

        this.props.userRefresh({
            email: null,
            imid: [],
            name: null,
            domain: null
        });

        this.props.setView(null);
        this.props.alert(TranslationService.trans(this.props.language, 'settings.account.actions.logout'));
    };

    /**
     * @param event
     */
    handleVoiceSettingsChange = (event)  => {
        this.setState({voice: event.target.value});

        if (event.target.value === 'enabled') {
            localStorage.setItem('voice', 'enabled');
        } else {
            localStorage.removeItem('voice');
        }
    };

    /**
     * @param event
     */
    handleTalkScreenSettingsChange = (event)  => {
        this.setState({talk_screen: event.target.value});

        if (event.target.value === 'calm') {
            localStorage.setItem('talk_screen', 'calm');
        } else {
            localStorage.removeItem('talk_screen');
        }
    };

    /**
     * @returns {XML}
     */
    render() {
        /* eslint-disable */
        return (
            <div className={this.getClass()} style={this.getStyle()} id="settings">
                <div className="content">
                    <div className="imd-tabs tabs-top">
                        <ul className="imd-tabs-navigation">
                            <li className={(this.state.tab === 'account' ? 'imd-active' : null)}>
                                <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'account'})}>
                                    {TranslationService.trans(this.props.language, 'settings.tabs.account')}
                                </a>
                            </li>
                            <li className={(this.state.tab === 'devices' ? 'imd-active' : null)}>
                                <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'devices'})}>
                                    {TranslationService.trans(this.props.language, 'settings.tabs.devices')}
                                </a>
                            </li>
                            <li className={(this.state.tab === 'app' ? 'imd-active' : null)}>
                                <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'app'})}>
                                    {TranslationService.trans(this.props.language, 'settings.tabs.app')}
                                </a>
                            </li>
                            <li className={(this.state.tab === 'license' ? 'imd-active' : null)}>
                                <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'license'})}>
                                    {TranslationService.trans(this.props.language, 'settings.tabs.license')}
                                </a>
                            </li>
                        </ul>

                        {/* Account */}
                        <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'account' ? ' imd-active' : '')}>
                            <div className="imd-container-fluid">
                                <div className="imd-row">
                                    <div className="imd-col-lg-4 imd-col-md-6 imd-col-xs-12">
                                        <div className="account imd-border-color-imid imd-text-accent">
                                            {(this.props.user && this.props.user.subscription === 'standard' ? <span className="imd-label imd-bg-imid imd-text-contrast">Standard</span> : null)}
                                            {(this.props.user && this.props.user.subscription !== 'standard' ? <span className="imd-label imd-text-gray" style={{background: '#ede9d9'}}>Premium</span> : null)}
                                            {/*{(this.props.user && this.props.user.subscription === 'enterprise' ? <span className="imd-label imd-bg-blue imd-text-white">Enterprise</span> : null)}*/}
                                            <img src="https://id.icymat.com/images/logo-light.png" alt="IMid" className="account-logo" />

                                            <br />
                                            <br />

                                            <img src={'https://id.icymat.com/avatar/' + (this.props.user ? MD5(this.props.user.email).toString() : 'noavatar')} alt={(this.props.user ? this.props.user.name + "'s avatar" : null)} className="avatar" />
                                            <strong className="imd-text-contrast">{TranslationService.trans(this.props.language, 'common.full_name')}: </strong> {(this.props.user ? this.props.user.name : null)}<br />
                                            <strong className="imd-text-contrast">{TranslationService.trans(this.props.language, 'common.security.email')}: </strong> {(this.props.user ? this.props.user.email : null)}<br />

                                            <br />
                                            <br />

                                            <Button
                                                color={'imid'}
                                                secondary={true}
                                                text={TranslationService.trans(this.props.language, 'common.security.sign_out')}
                                                size={'sm'}
                                                onClick={() => this.logout()}
                                            />
                                        </div>
                                    </div>

                                    <div className="imd-col-lg-4 imd-col-md-6 imd-col-xs-12">
                                        <div className="account imd-border-color-main imd-text-accent">
                                            <img src={'images/logo/' + TranslationService.trans(this.props.language, '_alphabet') + '.png'} alt="Andra" className="account-logo" />

                                            <br />
                                            <br />

                                            <strong className="imd-text-contrast">{TranslationService.trans(this.props.language, 'settings.account.andra.device')}: </strong> <span className="imd-text-accent">{this.getCurrentDeviceName()}</span><br />
                                            <strong className="imd-text-contrast">{TranslationService.trans(this.props.language, 'settings.account.andra.device_name')}: </strong> <span className="imd-text-accent">{this.props.device}</span>

                                            <br />
                                            <br />
                                            <hr style={{visibility: 'hidden'}} />

                                            <Button
                                                color={'main'}
                                                secondary={true}
                                                text={TranslationService.trans(this.props.language, 'common.security.sign_out')}
                                                size={'sm'}
                                                onClick={() => this.logout()}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'devices' ? ' imd-active' : '')}>
                            <h3 className="imd-text-accent">{TranslationService.trans(this.props.language, 'settings.devices.connected_devices')}</h3>
                            <div className="imd-table-responsive">
                                <table className="imd-table imd-table-bordered imd-border-color-accent imd-text-accent">
                                    <thead>
                                        <tr>
                                            <th>{TranslationService.trans(this.props.language, 'settings.devices.device_name')}</th>
                                            <th>{TranslationService.trans(this.props.language, 'settings.devices.device_id')}</th>
                                            <th>{TranslationService.trans(this.props.language, 'common.options')}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.renderDevices()}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* App */}
                        <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'app' ? ' imd-active' : '')}>
                            <h3 className="imd-text-accent">{TranslationService.trans(this.props.language, 'settings.app.settings')}</h3>

                            <Select
                                color={'main'}
                                value={this.state.voice}
                                required={true}
                                onChange={e => {this.handleVoiceSettingsChange(e)}}
                                values={{
                                    'enabled': TranslationService.trans(this.props.language, 'settings.app.enable_voice'),
                                    'disabled': TranslationService.trans(this.props.language, 'settings.app.disable_voice')
                                }}
                            />

                            <Select
                                color={'main'}
                                value={this.state.talk_screen}
                                required={true}
                                onChange={e => {this.handleTalkScreenSettingsChange(e)}}
                                values={{
                                    'standard': TranslationService.trans(this.props.language, 'settings.app.talk_screen.standard'),
                                    'calm': TranslationService.trans(this.props.language, 'settings.app.talk_screen.calm')
                                }}
                            />

                            <h3 className="imd-text-accent">{TranslationService.trans(this.props.language, 'settings.app.system_info.title')}</h3>
                            <strong>{TranslationService.trans(this.props.language, 'settings.app.system_info.version')}:</strong> {SystemInfoService.getVersion()}<br />
                            <strong>{TranslationService.trans(this.props.language, 'settings.app.system_info.build')}:</strong> {SystemInfoService.getBuild()}<br />
                        </div>

                        {/* License */}
                        <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'license' ? ' imd-active' : '')}>
                            <LicenseComponent />
                        </div>
                    </div>

                    <div className="madeby-mateusz-kolasa">
                        <p>made by</p>
                        <a href="https://mateuszkolasa.com" target="_blank">
                            <img src={"images/logo-mateuszkolasa-" + TranslationService.trans(this.props.language, '_alphabet') + ".svg"} alt="Mateusz Kolasa" />
                        </a>
                    </div>
                </div>

                <Confirmation
                    address={this.state.delete_device}
                    type="system"
                    onSuccess={this.deleteDeviceSuccess}
                    onError={this.deleteDeviceError}
                />

                <dialog className={(this.state.edit_device === null ? 'imd-dialog imd-bg-blur-black' : 'imd-dialog imd-bg-blur-black imd-opened')}>
                    <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                        <div className="imd-dialog-content">
                            <label>
                                {TranslationService.trans(this.props.language, 'settings.devices.device_name')}
                                <input type="text" className="imd-form-control imd-text-main" value={this.state.edit_device_name} onChange={e => {this.setState({edit_device_name: e.target.value});}} />
                            </label>
                        </div>

                        <footer>
                            <Button
                                color={'accent'}
                                secondary={true}
                                text={TranslationService.trans(this.props.language, 'common.cancel')}
                                onClick={() => this.setState({edit_device: null})}
                            />
                            <Button
                                color={'main'}
                                text={TranslationService.trans(this.props.language, 'common.save')}
                                onClick={() => this.saveDevice()}
                            />
                        </footer>
                    </div>
                </dialog>
            </div>
        );
        /* eslint-enable */
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        view: state.view
    }
};
const mapDispatchToProps = { preloaderShow, preloaderHide, alert, login, userRefresh, setView, topbarUpdate };

export const SettingsScreenContainer = connect(mapStateToProps, mapDispatchToProps)(SettingsScreen);
